import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { createPortal } from 'react-dom'
import Loader from "../../../common/Loader";
import Lightbox from "../../../common/LightBox";
import ImageComponent from '../../../common/Image';
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal';
import { documentGenerate, sendMail, setImeiNumber, setProductCost, setStage, setSubStage, shareLink, verifyEsignOtp } from '../../../../slices/eligibility/eligibilitySlice';
import { getApplicationData } from '../../../../slices/dashboard/dashboardSlice';

function Documents() {
    const [promoCommChecked, setPromoCommChecked] = useState(false);
    const [promoGreetChecked, setPromoGreetChecked] = useState(false);
    const { applicationDetail } = useSelector(state => state.eligibility);

    const href = "#";
    const dispatch = useDispatch();
    const urlParams = new URLSearchParams(window.location.search);
    const referenceId = urlParams.get('referenceId');
    const [loader, setLoader] = useState(false);
    let overlayStatus = applicationDetail?.kfs?.status === 'initiated' ? true : false
    const [overlay, setOverlay] = useState(overlayStatus);
    const [kfsUrl, setKfsUrl] = useState(applicationDetail?.kfs?.url);
    const pollingRef = useRef(null);
    const [showDetailModal, setShowDetailModal] = useState(false);
    const [showSelectRoleModal, setShowSelectRoleModal] = useState(false);
    const [applicationData, setApplicationData] = useState(null);
    const [showEsignButton, setShowEsignButton] = useState(false);
    const [showValidationSuccessModal, setShowValidationSuccessModal] = useState(false);
    const [otpKey, setOtpKey] = useState(0);
    const [esignView, SetEsignView] = useState(false)
    const [otpMobileNo, setOtpMobileNo] = useState(0);
    const [timer, setTimer] = useState("00:00:00");
    const Ref = useRef(null);
    const [otpValues, setOtpValues] = useState(['', '', '', '', '', '']);
    const [esign, setEsign] = useState(false)


    console.log(kfsUrl, "qqqqq")

    // Load application data on component mount
    useEffect(() => {
        const fetchApplicationData = async () => {
            if (!referenceId) return;

            try {
                setLoader(true);
                const payload = {
                    reference_id: referenceId
                };

                const response = await dispatch(getApplicationData(payload)).unwrap();

                if (response?.response_code === "S100") {
                    setApplicationData(response.response_data);
                    // Set E-Sign button visibility based on esign status
                    setShowEsignButton(response.response_data?.esign === true);
                } else {
                    !response?.payload?.error &&
                        toast.error(response?.response_string || 'Failed to fetch application data');
                }
            } catch (error) {
                console.error('Error fetching application data:', error);
                toast.error('Failed to fetch application data');
            } finally {
                setLoader(false);
            }
        };

        fetchApplicationData();
    }, [dispatch, referenceId]);


    useEffect(() => {
        if (!referenceId) return;

        let intervalId;

        const fetchApplicationData = async () => {
            try {
                const payload = { reference_id: referenceId };
                const response = await dispatch(getApplicationData(payload)).unwrap();

                if (response?.response_code === "S100") {
                    setApplicationData(response.response_data);

                    if (response.response_data?.esign === true) {
                        setShowEsignButton(true);
                        // ✅ stop polling once esign is true
                        if (intervalId) clearInterval(intervalId);
                    } else {
                        setShowEsignButton(false);
                    }
                } else {
                    !response?.payload?.error &&
                        toast.error(response?.response_string || "Failed to fetch application data");
                }
            } catch (error) {
                console.error("Error fetching application data:", error);
                toast.error("Failed to fetch application data");
            } finally {
            }
        };

        // initial call
        fetchApplicationData();

        // set up polling every 10 seconds
        intervalId = setInterval(fetchApplicationData, 10000);

        // cleanup on unmount
        return () => clearInterval(intervalId);
    }, [dispatch, referenceId]);


    const handleDocumentView = async (documentType) => {
        // Only show loader for KFS view (not generate)
        let showLoader = false;
        let action = (documentType === "KFS" && applicationData?.kfs_status === true) ? "view" : "generate";
        if (documentType === "KFS" && action === "view") {
            showLoader = true;
        }
        try {
            const payload = {
                reference_id: referenceId,
                document_type: documentType,
                language: "English",
                action
            };
            setLoader(true)
            const response = await dispatch(documentGenerate(payload)).unwrap();
            setLoader(false)
            if (response?.response_code === "S100") {
                SetEsignView(true)
                // Handle different response data structures
                const responseData = response?.response_data;

                if (responseData?.url) {
                    setKfsUrl(responseData.url)
                    // If URL is provided, open in new tab
                    window.open(responseData.url, '_blank');
                } else if (responseData?.kfs_image_base64 && payload.action === "view") {
                    // If KFS base64 is provided for view action, create blob and open
                    const pdfBlob = new Blob([Uint8Array.from(atob(responseData.kfs_image_base64), c => c.charCodeAt(0))],
                        { type: 'application/pdf' });
                    const pdfUrl = URL.createObjectURL(pdfBlob);
                    window.open(pdfUrl, '_blank');
                    // Clean up the URL after opening
                    setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
                } else if (responseData?.pdfBase64) {
                    // If base64 PDF is provided, create blob and open
                    const pdfBlob = new Blob([Uint8Array.from(atob(responseData.pdfBase64), c => c.charCodeAt(0))],
                        { type: 'application/pdf' });
                    const pdfUrl = URL.createObjectURL(pdfBlob);
                    window.open(pdfUrl, '_blank');
                    // Clean up the URL after opening
                    setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
                } else if (responseData?.letter_image_base64) {
                    // If base64 image/document is provided
                    const docBlob = new Blob([Uint8Array.from(atob(responseData.letter_image_base64), c => c.charCodeAt(0))],
                        { type: 'application/pdf' });
                    const docUrl = URL.createObjectURL(docBlob);
                    window.open(docUrl, '_blank');
                    // Clean up the URL after opening
                    setTimeout(() => URL.revokeObjectURL(docUrl), 1000);
                } else {
                    toast.error('Document not available for viewing');
                }

                // Refresh application data to update KFS status
                const refreshResponse = await dispatch(
                    getApplicationData({ reference_id: referenceId })
                ).unwrap();

                if (refreshResponse?.response_code === "S100") {
                    setApplicationData(refreshResponse.response_data);
                    setShowEsignButton(refreshResponse.response_data?.esign === true);
                }

                // If this was a KFS generate action, start polling for status
                if (documentType === "KFS" && action === "generate") {
                    setOverlay(true);
                }

                // Show success message if available
                if (responseData?.message) {
                    // toast.success(responseData.message);
                }
            } else {
                !response?.payload?.error &&
                    toast.error(response?.response_string || 'Failed to generate document');
            }
        } catch (error) {
            console.error('Error generating document:', error);
            toast.error('Failed to generate document');
        } finally {
            if (showLoader) setLoader(false);
            setShowDetailModal(false);
        }
    };

    const handleProceed = async () => {
        // Show validation success modal instead of directly proceeding
        setShowValidationSuccessModal(true);
    }

    const handleModalProceed = async () => {
        // Close the modal and proceed to next stage
        setLoader(true)
        const response = await dispatch(sendMail({ reference_id: referenceId, "document_type": "pre_do" })).unwrap()
        setLoader(false)
        if (response?.response_code === "S100") {
            setShowValidationSuccessModal(false);
            dispatch(setImeiNumber(response?.response_data?.imei_number));
            dispatch(setProductCost(response?.response_data?.product_cost));
            dispatch(setStage(response?.response_data?.stage || "imei_validation"));
            dispatch(setSubStage(response?.response_data?.sub_stage || "imei_validation"));
        }
        else {
            !response?.payload?.error &&
                toast.error(response?.response_string || 'Failed to generate document');
        }
    }

    const handleProceedClick = () => {
        if (!esign && !applicationData?.esign) {
            toast.error('Please complete E-Sign before proceeding');
            return;
        }
        handleProceed();
    };

    const handleModalView = () => {
        // Call handleDocumentView with pre_do
        handleDocumentView('pre_do');
    }

    const handleModalClose = useCallback(() => {
        setShowSelectRoleModal(false);
        setOtpValues(['', '', '', '', '', '']);
    }, []);

    const handleDocumentRetrieve = async () => {
        try {
            // Refresh application data to check latest status
            const payload = {
                reference_id: referenceId
            };
            const response = await dispatch(getApplicationData(payload)).unwrap();

            if (response?.response_code === "S100") {
                setApplicationData(response.response_data);
                setShowEsignButton(response.response_data?.esign === true);
                if (response.response_data?.kfs_status === true) {
                    setOverlay(false);
                } else {
                    setOverlay(true);
                    toast.warning('KFS generation still in progress');
                }
            } else {
                !response?.payload?.error &&
                    toast.error(response?.response_string || 'Failed to retrieve status');
                setOverlay(true);
            }
        } catch (error) {
            console.error('Error retrieving status:', error);
            toast.error('Failed to retrieve status');
            setOverlay(true);
        }
    };

    const pollKfsStatus = useCallback(async () => {
        try {
            if (applicationDetail?.kfs?.status !== 'complete') {

                const response = await dispatch(getApplicationData({ reference_id: referenceId })).unwrap();

                if (response?.response_code === "S100") {
                    setApplicationData(response.response_data);
                    setShowEsignButton(response.response_data?.esign === true);

                    if (response.response_data?.kfs_status === true) {
                        setOverlay(false);
                    }
                }
            }
        } catch (err) {
            // ignore polling errors
        }
    }, [dispatch, referenceId]);


    // Polling for KFS status when overlay is active
    useEffect(() => {
        if (!overlay) {
            // ensure cleanup when overlay turns false
            if (pollingRef.current) {
                clearInterval(pollingRef.current);
                pollingRef.current = null;
            }
            return;
        }

        // create interval ONCE when overlay becomes true
        pollingRef.current = setInterval(() => {
            pollKfsStatus();
        }, 60000); // 60s

        // cleanup when unmount or overlay changes
        return () => {
            if (pollingRef.current) {
                clearInterval(pollingRef.current);
                pollingRef.current = null;
            }
        };
    }, [overlay, pollKfsStatus]);


    const getUserLocation = async (shouldUseGeolocation = true) => {
        if (!shouldUseGeolocation) {
            // Prevent unnecessary access
            return Promise.reject(new Error("Geolocation access is not necessary."));
        }

        if (!navigator.geolocation) {
            toast.error('Geolocation is not supported by your browser');
            return Promise.reject(new Error("Geolocation is not supported by your browser"));
        }

        return new Promise((resolve, reject) => {
            // ⚠️ Only call this if geolocation is truly necessary
            //NOSONAR
            navigator.geolocation.getCurrentPosition( //NOSONAR
                (position) => {
                    resolve(position.coords);
                },
                (err) => {
                    if (err.code === 1) {
                        toast.error('Please allow location access to continue');
                    } else {
                        toast.error('Error getting location');
                    }
                    reject(err);
                }
            );
        });
    };

    const handleVerifyClick = async () => {
        setLoader(true)
        const location = await getUserLocation();
        let data = {
            "reference_id": referenceId,
            latitude: location.latitude,
            longitude: location.longitude,
            "otp": otpValues?.join(''),
        }
        const response = await dispatch(verifyEsignOtp(data)).unwrap()
        setLoader(false)
        if (response?.response_code === "S100") {
            setShowSelectRoleModal(false);
            setEsign(true);
            setOtpValues(['', '', '', '', '', '']);
        }
        else {
            !response?.payload?.error &&
                toast.error(response?.response_string || 'Failed to generate document');
        }
    }

    // Check KFS status and close overlay if true

    const otpTrigger = async () => {
        // First, check esign status by calling getApplicationData
        setLoader(true);
        try {
            const statusResponse = await dispatch(getApplicationData({ reference_id: referenceId })).unwrap();
            if (statusResponse?.response_code === "S100") {
                const esignStatus = statusResponse.response_data?.esign;
                if (esignStatus === true) {
                    // E-sign already done, do not call documentGenerate
                    window.location.reload();
                    setLoader(false);
                    return;
                }
            } else {
                toast.error(statusResponse?.response_string || 'Failed to check E-Sign status');
                setLoader(false);
                return;
            }

            // If esign is not done, proceed to call documentGenerate
            const location = await getUserLocation();
            const payload = {
                reference_id: referenceId,
                document_type: "esign",
                terms_agreed: true,
                promo_comm_agreed: promoCommChecked,
                promo_greet_agreed: promoGreetChecked,
                latitude: location.latitude,
                longitude: location.longitude,
            };
            const response = await dispatch(documentGenerate(payload)).unwrap();
            if (response?.response_code === "S100") {
                setOtpValues(['', '', '', '', '', ''])
                setOtpMobileNo(response?.response_data?.mobile_number)
                setShowSelectRoleModal(true)
                setTimer("01:00");
                clearTimer(getDeadTime());
            } else {
                !response?.payload?.error &&
                    toast.error(response?.response_string || 'Failed to generate document');
            }
        } catch (error) {
            toast.error('Failed to check E-Sign status');
        } finally {
            setLoader(false);
        }
    }

    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());  // Get total remaining time in milliseconds
        const seconds = Math.floor((total / 1000) % 60);  // Remaining seconds
        const minutes = Math.floor((total / 1000 / 60) % 60);  // Remaining minutes

        return { total, minutes, seconds };
    };

    // Function to start the timer and update the state
    const startTimer = (e) => {
        let { total, minutes, seconds } = getTimeRemaining(e);
        if (total >= 0) {
            // Update the timer if time is still remaining
            setTimer(
                (minutes > 9 ? minutes : "0" + minutes) + ":" + (seconds > 9 ? seconds : "0" + seconds)
            );
        } else {
            // If time is over, clear the interval
            clearInterval(Ref.current);
        }
    };

    // Function to clear the previous interval and start a new one
    const clearTimer = (e) => {
        setTimer("01:00");  // Reset timer to 120 seconds (2 minutes)

        // Clear the previous interval (if any)
        if (Ref.current) clearInterval(Ref.current);

        // Set a new interval to update the timer every second
        const id = setInterval(() => {
            startTimer(e);
        }, 1000);
        Ref.current = id;  // Store the interval ID in Ref
    };

    // Function to get the deadline (current time + 120 seconds)
    const getDeadTime = () => {
        let deadline = new Date();
        deadline.setSeconds(deadline.getSeconds() + 60);  // Add 120 seconds (2 minutes)
        return deadline;
    };

    const handleOtpChange = (index, value) => {
        // Allow only digits
        if (!/^\d*$/.test(value)) return;

        const newOtpValues = [...otpValues];
        newOtpValues[index] = value.slice(-1); // Ensure only the last digit is used
        setOtpValues(newOtpValues);

        // Auto-move to next input
        if (value && index < otpValues.length - 1) {
            const nextInput = document.querySelector(`input[data-index="${index + 1}"]`);
            if (nextInput) nextInput.focus();
        }
    };

    const handleOtpKeyDown = (index, e) => {
        const key = e.key;

        if (key === 'Backspace') {
            if (otpValues[index]) {
                // Clear current value
                const newOtpValues = [...otpValues];
                newOtpValues[index] = '';
                setOtpValues(newOtpValues);
            } else if (index > 0) {
                // Move focus to previous input
                const prevInput = document.querySelector(`input[data-index="${index - 1}"]`);
                if (prevInput) prevInput.focus();
            }
        }

        if (key === 'ArrowLeft' && index > 0) {
            const prevInput = document.querySelector(`input[data-index="${index - 1}"]`);
            if (prevInput) prevInput.focus();
        }

        if (key === 'ArrowRight' && index < otpValues.length - 1) {
            const nextInput = document.querySelector(`input[data-index="${index + 1}"]`);
            if (nextInput) nextInput.focus();
        }
    };

    const handleOtpPaste = (e) => {
        e.preventDefault();
        const paste = e.clipboardData.getData('text').trim().replace(/\D/g, ''); // numbers only
        if (paste.length === otpValues.length) {
            setOtpValues(paste.split(''));
            // Optional: move focus to last input
            const lastInput = document.querySelector(`input[data-index="${otpValues.length - 1}"]`);
            if (lastInput) lastInput.focus();
        }
    };

    const [otpIds] = React.useState(() =>
        otpValues.map(() => crypto.randomUUID()) // or some unique ID generator
    );

    const shareCustomerLink = async () => {
        setLoader(true)
        const response = await dispatch(shareLink({ "reference_id": referenceId, "document_type": "share_link" })).unwrap()
        setLoader(false)
        if (response?.response_code === "S100") {
            toast.success(response?.response_string)
        }
        else {
            !response?.payload?.error &&
                toast.error(response?.response_string)
        }
    }
    // Memoize the OTP modal to prevent re-rendering
    const otpModal = useMemo(() => (
        <Modal
            id="otpModal"
            show={showSelectRoleModal}
            onClose={handleModalClose}
            modalClass="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg bottom-modal"
        >
            <ModalBody className="mt-3 mb-3">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                        <ImageComponent fileName="eligibleotp.svg" alt="eligibleotp" />
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                        <p className="form-label fw-semibold fs-6">Please enter OTP</p>
                        <p className="form-label fs-7">
                            6 digit code has been sent to :
                        </p>
                        <div className="mt-2">
                            <p className="fw-semibold form-label fs-7">
                                +91{otpMobileNo}
                            </p>
                        </div>
                        <div className="col-lg-12 col-md-12 col-sm-12 mt-3">
                            <div>
                                <div className="d-flex gap-3 mb-4">
                                    {otpValues.map((value, index) => (
                                        <input
                                            key={otpIds[index]}
                                            type="tel"
                                            maxLength="1"
                                            value={value}
                                            onChange={(e) => handleOtpChange(index, e.target.value)}
                                            onKeyDown={(e) => handleOtpKeyDown(index, e)}
                                            onPaste={handleOtpPaste}
                                            data-index={index}
                                            className="otp-in input-underline otp-input"
                                            inputMode="numeric"
                                            autoComplete="one-time-code"
                                        />
                                    ))}
                                </div>
                            </div>
                        </div>
                        <p className="text-start small text-secondary">
                            {timer !== "00:00" ? (
                                `Resend OTP in ${timer} seconds`
                            ) : (
                                <a
                                    href={href}
                                    tabIndex={0}
                                    className="anchor-btn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        otpTrigger();
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            otpTrigger();
                                        }
                                    }}
                                >
                                    Resend
                                </a>
                            )}
                        </p>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
                        <button
                            className="btn btn-primary btn-lg w-100 signin"
                            type="button"
                            onClick={handleVerifyClick}
                        >
                            Verify
                        </button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
    ), [showSelectRoleModal, handleOtpChange, handleModalClose, handleVerifyClick, timer, href]);

    return (
        <>
            {overlay === true && createPortal(<Lightbox stage="document" onRetrieve={handleDocumentRetrieve} mandateUrl={kfsUrl} />, document.body)}
            {loader === true && <Loader />}
            <div className="col-md-9 col-sm-12 Side-bank-Right">
                <div className="row bg-white gy-4 mb-4">

                    {/* KFS Document */}
                    <div
                        className="col-12 col-lg-12 col-md-12"
                        onClick={() => {
                            if (applicationData?.kfs_status === true) {
                                setOverlay(false);
                            }
                            handleDocumentView('KFS');
                        }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                setOverlay(true);
                                if (applicationData?.kfs_status === true) {
                                    setOverlay(false);
                                }
                                handleDocumentView('KFS');
                            }
                        }}
                        tabIndex={0}
                        role="button"
                        aria-label="View KFS document"
                    >
                        <div className={`document-details p-3 ${(esignView === true || applicationData?.kfs_status === true) ? 'active-doc-div' : ''}`}>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="lh-2 d-flex gap-3 align-items-center">
                                    <ImageComponent fileName="filed.svg" alt="filed" />
                                    <div>
                                        <p className="fw-semibold mt-0">{applicationData?.kfs_status === true ? 'View KFS' : 'Generate KFS'}</p>
                                    </div>
                                </div>
                                {/* Show tick icon at the end if kfs_status is true, otherwise show nothing */}
                                {applicationData?.kfs_status === true ? (
                                    <ImageComponent fileName="tick-icon.svg" alt="tick" />
                                ) : null}
                            </div>
                        </div>
                    </div>

                    {/* Sanction Letter Document */}
                    <div className="col-4 col-lg-4 col-md-4" onClick={() => {
                        handleDocumentView('sanction_letter');
                    }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                handleDocumentView('sanction_letter');
                            }
                        }}
                        type="button"
                        tabIndex={0}
                        role="button"
                        aria-label="View Sanction Letter document">
                        <div className={`document-details p-2 new-border ${(esignView === true || applicationData?.kfs_status === true) ? 'active-doc-div' : 'doc-disable'}`}>
                            <div className="">
                                <div className="lh-2">
                                    <ImageComponent fileName="pdf2.svg" alt="filed" />
                                    <div>
                                        <p className="fw-semibold mt-3 small">Sanction Letter</p>
                                    </div>
                                </div>
                                {/* Show tick icon at the end if kfs_status is true, otherwise show nothing */}
                                {applicationData?.kfs_status === true ? (
                                    <ImageComponent fileName="tick-icon.svg" alt="tick" className={"d-none"} />
                                ) : null}
                            </div>
                        </div>
                    </div>

                    {/* Application Document */}
                    <div className="col-4 col-lg-4 col-md-4" onClick={() => {
                        handleDocumentView('application');
                    }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                handleDocumentView('application');
                            }
                        }}
                        type="button"
                        tabIndex={0}
                        role="button"
                        aria-label="View Application document">
                        <div className={`document-details p-2 new-border ${(esignView === true || applicationData?.kfs_status === true) ? 'active-doc-div' : 'doc-disable'}`}>
                            <div className="">
                                <div className="lh-2">
                                    <ImageComponent fileName="pdf2.svg" alt="filed" />
                                    <div>
                                        <p className="fw-semibold mt-3 small">Application</p>
                                    </div>
                                </div>
                                {/* Show tick icon at the end if kfs_status is true, otherwise show nothing */}
                                {applicationData?.kfs_status === true ? (
                                    <ImageComponent fileName="tick-icon.svg" alt="tick" className={"d-none"} />
                                ) : null}
                            </div>
                        </div>
                    </div>

                    {/* Terms & Conditions Document */}
                    <div className="col-4 col-lg-4 col-md-4" onClick={() => {
                        handleDocumentView('terms_condition');
                    }}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                handleDocumentView('terms_condition');
                            }
                        }}
                        tabIndex={0}
                        role="button"
                        type="button"
                        aria-label="View Terms & Conditions document">
                        <div className={`document-details p-2 new-border ${(esignView === true || applicationData?.kfs_status === true) ? 'active-doc-div' : 'doc-disable'}`}>
                            <div className="">
                                <div className="lh-2">
                                    <ImageComponent fileName="pdf2.svg" alt="filed" />
                                    <div>
                                        <p className="fw-semibold mt-3 small">Terms & Conditions</p>
                                    </div>
                                </div>
                                {/* Show tick icon at the end if kfs_status is true, otherwise show nothing */}
                                {applicationData?.kfs_status === true ? (
                                    <ImageComponent fileName="tick-icon.svg" alt="tick" className={"d-none"} />
                                ) : null}
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-lg-12 col-md-12 d-none doc-margin">
                        <div className={`document-details ps-3 pe-3 py-2 ${(esignView === true || applicationData?.kfs_status === true) ? 'active-doc-div' : ''}`}>
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="lh-2 d-flex gap-3 align-items-center">
                                    <ImageComponent fileName="filed.svg" alt="filed" />
                                    <div>
                                        <p className="fw-semibold mt-0">OSV Document</p>
                                    </div>
                                </div>
                                <i className={`icon-securityeye fs-5 dark-blue ${(esignView === true || applicationData?.kfs_status === true) ? 'active-doc-view-icon' : ''}`}
                                    onClick={() => {
                                        handleDocumentView('osv');
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            handleDocumentView('osv');
                                        }
                                    }}
                                    tabIndex={0}
                                    role="button"
                                    type="button"
                                    aria-label="View OSV Document"></i>
                            </div>
                        </div>
                    </div>


                    <div className="col-12">
                        <div className="d-flex align-items-center justify-content-end">
                            <a
                                href={href}
                                className={`small ${applicationData?.kfs_status !== true ? ' disabled-link' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (applicationData?.kfs_status === true) {
                                        shareCustomerLink();
                                    } else {
                                        toast.warning('Please complete KFS generation');
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        if (applicationData?.kfs_status === true) {
                                            shareCustomerLink();
                                        } else {
                                            toast.warning('Please complete KFS generation');
                                        }
                                    }
                                }}
                                tabIndex={0}
                                role="button"
                                aria-disabled={applicationData?.kfs_status !== true}
                            >
                                <ImageComponent fileName="ico-share.svg" className="img-fluid me-1" alt="ico-share" />
                                SHARE LINK
                            </a>
                        </div>
                    </div>

                    {/* Conditionally render E-Sign button based on esign status */}
                    {((showEsignButton || esignView || applicationData?.kfs_status === true) && (!esign && !applicationData?.esign)) && (
                        <div className="col-12">
                            <div className="mb-3">
                                <p className="mb-3 promo-content fs-12">
                                    I hereby permit CIFCL to send SMS/email/notifications and call me for communication relating to
                                    <br />
                                    a) Any transactional messages related to my loan account/s (mandatory),<br />
                                    b) Non-transactional communications (optional), by ticking the box/es below:
                                </p>
                                <div className="form-check mb-2 d-flex align-items-center gap-2 ps-0">
                                    <input
                                        className="form-check-input m-0 mt-1 promoCommCheckbox"
                                        type="checkbox"
                                        id="promoCommCheckbox"
                                        checked={promoCommChecked}
                                        onChange={e => setPromoCommChecked(e.target.checked)}
                                    />
                                    <label className="form-check-label mb-0 promo-content" htmlFor="promoCommCheckbox">
                                        Any commercial, marketing and promotional messages relating to the loans/services or such other related products
                                    </label>
                                </div>
                                <div className="form-check mb-2 d-flex align-items-center gap-2 ps-0">
                                    <input
                                        className="form-check-input m-0 mt-1 promoCommCheckbox"
                                        type="checkbox"
                                        id="promoGreetCheckbox"
                                        checked={promoGreetChecked}
                                        onChange={e => setPromoGreetChecked(e.target.checked)}
                                    />
                                    <label className="form-check-label mb-0 promo-content" htmlFor="promoGreetCheckbox">
                                        Any season greetings including birth/wedding day greetings
                                    </label>
                                </div>
                            </div>
                            <button className="btn btn-outline-primary e-sign-btn" type="button" onClick={() => otpTrigger()} disabled={!promoCommChecked}>
                                E-Sign
                            </button>
                            <button className="btn btn-outline-primary d-none" type="button">
                                <ImageComponent fileName="image 133.png" alt="image 133" />
                            </button>
                        </div>
                    )}
                    {(esign || applicationData?.esign) &&
                        <div className="col-12">
                            <button className="btn btn-outline-primary" type="button">
                                <ImageComponent fileName="image 133.png" alt="image 133" />
                            </button>
                        </div>
                    }
                </div>
            </div >

            {(esign || applicationData?.esign) &&
                <footer className="sticky-bottom-1">
                    <div className="container-fluid ">
                        <div className="row">
                            <div className="col-sm-12 ">
                                <div className="d-flex justify-content-end">
                                    <button className="btn btn-primary" type="button" onClick={handleProceedClick}>Proceed</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>}

            <Modal
                id="detailicon"
                show={showDetailModal}
                onClose={() => setShowDetailModal(false)}
                modalClass="modal-dialog modal-dialog-centered"
                contentClass="eye-action"
            >
                <div className="ps-3 pe-3 py-3 text-center d-flex gap-3 align-items-center">
                    <ImageComponent fileName="eye.svg" alt="eye" onClick={() => handleDocumentView('KFS')}
                        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleDocumentView('KFS')}
                        tabIndex={0}
                        role="button" />
                    <ImageComponent fileName="editwifi.svg" alt="editwifi" onClick={() => handleDocumentView('KFS')}
                        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleDocumentView('KFS')}
                        tabIndex={0}
                        role="button" />
                </div>
            </Modal>

            {otpModal}

            <Modal
                id="successModal"
                show={showValidationSuccessModal}
                onClose={() => setShowValidationSuccessModal(false)}
                modalClass="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg bottom-modal"
            >
                <ModalHeader className="">
                    <div className="top-draw"></div>
                </ModalHeader>
                <ModalBody className="mt-3 mb-3">
                    <div className="ps-3 pe-3 py-3 text-center">
                        <ImageComponent fileName="2fverify.svg" />
                        <p className="m-0 mt-3">Pre-DO has been sent to the Dealer on</p>
                        <p className="fw-semibold">{applicationData?.dealer_email_id}</p>
                        <div className="d-flex gap-4 justify-content-center">
                            <button className="btn btn-primary btn-lg signin flex-fill" type="button" onClick={handleModalView}>
                                <i className='icon-securityeye'></i> View
                            </button>
                            <button className="btn btn-primary btn-lg signin flex-fill" type="button" onClick={handleModalProceed}>
                                Proceed
                            </button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
}

export default Documents